import { render, staticRenderFns } from "./ContratosList.vue?vue&type=template&id=64c0f700&scoped=true"
import script from "./ContratosList.vue?vue&type=script&lang=js"
export * from "./ContratosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0f700",
  null
  
)

export default component.exports